import { Schema } from 'rsuite'

const { StringType, ArrayType, NumberType } = Schema.Types

export const CategoryFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  xid: StringType()
    .isRequired('Заполните ID в ТУС')
    .minLength(1, 'Минимальное количество символов 1')
})
